'use strict'
import { z } from 'zod/mini'

/** 判定ルール行スキーマ（DynamoDB形式） */
export const JudgmentRuleRowSchema = z.object({
  RuleId: z.string(),
  RuleName: z.optional(z.string()),
  ValidStartMonth: z.optional(z.string()),
  ValidEndMonth: z.optional(z.string()),
  PeriodKind: z.optional(z.string()),
  DataKindName: z.optional(z.string()),
  DataKindCode: z.optional(z.string()),
  ChrofyColumnName: z.optional(z.string()),
  ChrofyColumnCode: z.optional(z.string()),
  CreateUserName: z.optional(z.string()),
  CreateDateTime: z.optional(z.string()),
  UpdateUserName: z.optional(z.string()),
  UpdateDateTime: z.optional(z.string()),
  Status: z.array(z.string()),
  PeriodNameList: z.array(z.string())
})

/**
 * 判定ルール行型
 *
 * @typedef {z.infer<typeof JudgmentRuleRowSchema>} JudgmentRuleRow
 */
